var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mx-5" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "concept-title col-11" }, [
        _vm._v("\n      " + _vm._s(_vm.concept.concept.id) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-1 pt-2 pr-5" },
        [
          _c(
            "b-button",
            {
              staticClass: "btn btn-outline-success",
              attrs: {
                size: "sm",
                href:
                  _vm.downloadUrl +
                  _vm.extractConceptFromId(_vm.concept.concept.id) +
                  ".ttl",
                download: ""
              }
            },
            [_vm._v("Download")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.concept.types
      ? _c("div", { staticClass: "row paragraph" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table10 col-10" },
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  small: "",
                  hover: "",
                  fields: _vm.fieldsOblank,
                  items: _vm.concept.types
                },
                scopedSlots: _vm._u([
                  {
                    key: "object",
                    fn: function(data) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "t-row",
                            attrs: { id: "link" },
                            on: {
                              click: function($event) {
                                _vm.onClicked($event, data.item.object)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.getLabelOrId(data.item.object)))]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.concept.literals
      ? _c("div", { staticClass: "row paragraph" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table10  col-10" },
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  small: "",
                  hover: "",
                  fields: _vm.fieldsLiterals,
                  items: _vm.concept.literals
                },
                scopedSlots: _vm._u([
                  {
                    key: "property",
                    fn: function(data) {
                      return [
                        _c("div", { staticClass: "t-row" }, [
                          _vm._v(_vm._s(_vm.getLabelOrId(data.item.predicate)))
                        ])
                      ]
                    }
                  },
                  {
                    key: "value",
                    fn: function(data) {
                      return [
                        _c("div", { staticClass: "t-row" }, [
                          _vm._v(_vm._s(_vm.getLabelOrId(data.item.object)))
                        ])
                      ]
                    }
                  },
                  {
                    key: "language",
                    fn: function(data) {
                      return [
                        _c("div", { staticClass: " t-row" }, [
                          _vm._v(_vm._s(data.item.object.language))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row paragraph" }, [
      _vm.concept.superClasses
        ? _c("div", { staticClass: "col-6 row" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table8 col-8 " },
              [
                _c("b-table", {
                  attrs: {
                    striped: "",
                    small: "",
                    hover: "",
                    fields: _vm.fieldsOblank,
                    items: _vm.concept.superClasses
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "object",
                      fn: function(data) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "t-row",
                              attrs: { id: "link" },
                              on: {
                                click: function($event) {
                                  _vm.onClicked($event, data.item.object)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.getLabelOrId(data.item.object)))]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.concept.subClasses
        ? _c("div", { staticClass: "col-6 row" }, [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table8 col-8 " },
              [
                _c("b-table", {
                  attrs: {
                    striped: "",
                    small: "",
                    hover: "",
                    fields: _vm.fieldsOblank,
                    items: _vm.concept.subClasses
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "object",
                      fn: function(data) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "t-row",
                              attrs: { id: "link" },
                              on: {
                                click: function($event) {
                                  _vm.onClicked($event, data.item.subject)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getLabelOrId(data.item.subject))
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row paragraph" }, [
      _vm.concept.broaders
        ? _c("div", { staticClass: "col-6 row" }, [
            _vm._m(4),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table8  col-8" },
              [
                _c("b-table", {
                  attrs: {
                    striped: "",
                    small: "",
                    hover: "",
                    fields: _vm.fieldsOblank,
                    items: _vm.concept.broaders
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "object",
                      fn: function(data) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "t-row",
                              attrs: { id: "link" },
                              on: {
                                click: function($event) {
                                  _vm.onClicked($event, data.item.object)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.getLabelOrId(data.item.object)))]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.concept.narrowers
        ? _c("div", { staticClass: "col-6 row" }, [
            _vm._m(5),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table8 col-8" },
              [
                _c("b-table", {
                  attrs: {
                    striped: "",
                    small: "",
                    hover: "",
                    fields: _vm.fieldsOblank,
                    items: _vm.concept.narrowers
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "object",
                      fn: function(data) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "t-row",
                              attrs: { id: "link" },
                              on: {
                                click: function($event) {
                                  _vm.onClicked($event, data.item.object)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.getLabelOrId(data.item.object)))]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.concept.incomingConcepts
      ? _c("div", { staticClass: "row paragraph" }, [
          _vm._m(6),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table10 col-10 " },
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  small: "",
                  hover: "",
                  fields: _vm.fieldsIncoming,
                  items: _vm.concept.incomingConcepts
                },
                scopedSlots: _vm._u([
                  {
                    key: "subject",
                    fn: function(data) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "t-row",
                            attrs: { id: "link" },
                            on: {
                              click: function($event) {
                                _vm.onClicked($event, data.item.subject)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.getLabelOrId(data.item.subject)))]
                        )
                      ]
                    }
                  },
                  {
                    key: "predicate",
                    fn: function(data) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "t-row",
                            attrs: { id: "link" },
                            on: {
                              click: function($event) {
                                _vm.onClicked($event, data.item.predicate)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.getLabelOrId(data.item.predicate))
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "object",
                    fn: function(data) {
                      return [
                        _c(
                          "div",
                          { staticClass: "t-row", attrs: { id: "link" } },
                          [_vm._v(_vm._s(_vm.getLabelOrId(data.item.object)))]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.concept.properties
      ? _c("div", { staticClass: "row paragraph" }, [
          _vm._m(7),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table10 col-10" },
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  small: "",
                  hover: "",
                  fields: _vm.fieldsProperty,
                  items: _vm.concept.properties
                },
                scopedSlots: _vm._u([
                  {
                    key: "predicate",
                    fn: function(data) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "t-row",
                            attrs: { id: "link" },
                            on: {
                              click: function($event) {
                                _vm.onClicked($event, data.item.predicate)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.getLabelOrId(data.item.predicate))
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "object",
                    fn: function(data) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "t-row",
                            attrs: { id: "link" },
                            on: {
                              click: function($event) {
                                _vm.onClicked($event, data.item.object)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.getLabelOrId(data.item.object)))]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row paragraph" }, [
      _vm.concept.instances
        ? _c("div", { staticClass: "col-6 row" }, [
            _vm._m(8),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table8 col-8 " },
              [
                _c("b-table", {
                  attrs: {
                    striped: "",
                    small: "",
                    hover: "",
                    fields: _vm.fieldsInstances,
                    items: _vm.concept.instances
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "subject",
                      fn: function(data) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "t-row",
                              attrs: { id: "link" },
                              on: {
                                click: function($event) {
                                  _vm.onClicked($event, data.item.subject)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getLabelOrId(data.item.subject))
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row paragraph" }, [
      _vm.concept.domains
        ? _c("div", { staticClass: "col-6 row " }, [
            _vm._m(9),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table8 col-8" },
              [
                _c("b-table", {
                  attrs: {
                    striped: "",
                    small: "",
                    hover: "",
                    fields: _vm.fieldsOblank,
                    items: _vm.concept.domains
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "object",
                      fn: function(data) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "t-row",
                              attrs: { id: "link" },
                              on: {
                                click: function($event) {
                                  _vm.onClicked($event, data.item.subject)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getLabelOrId(data.item.subject))
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.concept.ranges
        ? _c("div", { staticClass: "col-6 row" }, [
            _vm._m(10),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table8 col-8" },
              [
                _c("b-table", {
                  attrs: {
                    striped: "",
                    small: "",
                    hover: "",
                    fields: _vm.fieldsOblank,
                    items: _vm.concept.ranges
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "object",
                      fn: function(data) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "t-row",
                              attrs: { id: "link" },
                              on: {
                                click: function($event) {
                                  _vm.onClicked($event, data.item.subject)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getLabelOrId(data.item.subject))
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("div", { staticClass: "chapter-title" }, [_vm._v("Type")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("div", { staticClass: "chapter-title" }, [_vm._v("Literals")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4 p-0" }, [
      _c("div", { staticClass: "chapter-title" }, [_vm._v("Super classes")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4" }, [
      _c("div", { staticClass: "chapter-title" }, [_vm._v("Sub Classes")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4" }, [
      _c("div", { staticClass: "chapter-title" }, [_vm._v("Broader")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4" }, [
      _c("div", { staticClass: "chapter-title" }, [_vm._v("Narrower")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2" }, [
      _c("div", { staticClass: "chapter-title" }, [_vm._v("Other relations")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-2 " }, [
      _c("div", { staticClass: "chapter-title" }, [_vm._v("Properties")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4" }, [
      _c("div", { staticClass: "chapter-title" }, [_vm._v("Instances")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4" }, [
      _c("div", { staticClass: "chapter-title" }, [_vm._v("Domain")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-4" }, [
      _c("div", { staticClass: "chapter-title" }, [_vm._v("Range")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ce6d3e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ce6d3e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConceptPane.vue
// module id = null
// module chunks = 